import React, { useEffect, useState } from "react";
import VulscanTypeField from "./VulscanTypeField";
import * as vulscanService from "./vulscanService";
//import { TableContext } from "../index";
import VulscanTargetField from "./VulscanTargetField";
import VulscanCommandField from "./VulscanCommandField";
import ScanButton from "./ScanButton";
import ScheduleScanButton from "./ScheduleScanButton";
import ScanSearchSection from "./ScanSearchSection";

export function VulscanConfigManagement() {

    const initialState = {
        details: '',
        command: '',
        target:'',
        selectedType: null,
    }

    const [state, setState] = useState(initialState);
    const [scanStatus, setScanStatus] = useState('');
    const [scanTypesData, setScanTypesData] = useState([]);
 

    const fetchData = async () => {
        try {
            const VulscanConfigList = await vulscanService.getVulscanConfigs();
            setScanTypesData(VulscanConfigList);
            //const [deviceList, deviceTypeList, msbList] = await Promise.all([deviceListPromise, deviceTypeListPromise, msbListPromise]);

            // let type;
            // const pageFilters = getFilers(true);
            // if (pageFilters.type) {
            //     type = nmapConfigList.find(type => type.type === pageFilters.type);
            // }
            // let newTableConfig = config;
            // //if (type) {
            //     newTableConfig = { ...newTableConfig, typeId: "-1" };
            //    // setTypeId(type.id);
            // //}
            // setConfig({ ...newTableConfig });

        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchData();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);


    const onTypeChange = (value, details, command) => {
        setState({
          ...state,
          selectedType: value,
          details: details,
          command: command,
        });
      }

    const onTargetChange = (value) => {
        //let commandText = state.command;
        setState({
        ...state,
        target: value,
        //command: commandText + " " + state.target
    });
    };

    const onCommandChange = (value) => {
    // setState({
    //     ...state,
    //     command: value
    // });
    };
      

    const isDetailsValid = () => state.details && state.details.length > 0;

    return (
        <div className="container-fluid">
            <section className="network-scan-config-v2">
                <div className="network-scan-config-header-v2">
                    <div>
                        <h2 className="network-scan-title-v2">Vulnerability Scan</h2>
                        <p className="network-scan-subtitle-v2">Configure, run or schedule an Nmap vulnerability scan</p>
                    </div>
                </div>
                <form action="" className="network-scan-form-v2">
                    <div className="network-scan-form-grid-v2">
                        <div className="network-scan-field-v2">
                            <VulscanTypeField types={scanTypesData}
                                value={state.selectedType}
                                onChange={onTypeChange}/>
                        </div>
                        <div className="network-scan-field-v2">
                            <VulscanTargetField value={state.target}
                                onChange={onTargetChange}/>
                        </div>
                        {isDetailsValid() && <div className="network-scan-details-v2">
                            <span className="network-scan-details-label-v2">Scan details</span>
                            {state.details}
                        </div>}
                        <div className={isDetailsValid() ? "network-scan-field-v2" : "network-scan-field-v2--full"}>
                            <VulscanCommandField value={state.command + " " + state.target}
                                onChange={onCommandChange}/>
                        </div>
                    </div>
                    <div className="network-scan-action-bar-v2">
                        <div className="network-scan-button-group-v2">
                            <ScanButton target={state.target}
                                command={state.command}
                                type={state.selectedType}
                                scanStatus={scanStatus}
                                setScanStatus={setScanStatus}/>
                            <ScheduleScanButton types={scanTypesData}
                                selectedType={state.selectedType}
                                setType={onTypeChange}
                                inputTarget={state.target}
                                setTarget={onTargetChange}
                                inputCommand={state.command}/>
                        </div>
                        <ScanSearchSection />
                    </div>
                </form>
            </section>
        </div>
    )
}
